import type { SVGProps } from 'react'

const WarningDiamond = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.4142 2.4142L17.5858 8.5858A2 2 0 0 1 17.5858 11.4142L11.4142 17.5858A2 2 0 0 1 8.5858 17.5858L2.4142 11.4142A2 2 0 0 1 2.4142 8.5858L8.5858 2.4142A2 2 0 0 1 11.4142 2.4142Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 10.556L10 6.2782"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 13.306V13.2504"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default WarningDiamond
